import TagManager from "react-gtm-module";
const tagManagerEvents = (eventName: string, utm_source: string | null) => {
  // console.warn("this is event name", eventName, "utm source", utm_source);
  const tagManagerArgs = {
    dataLayer: {
      event: eventName,
      utm_source: utm_source,
    },
  };
  TagManager.dataLayer(tagManagerArgs);
};

export const AwarenessTagManagerEvents = (data: any) => {
  const tagManagerArgs = {
    dataLayer: data,
  };
  TagManager.dataLayer(tagManagerArgs);
};

export default tagManagerEvents;
